module.exports = __webpack_public_path__ + "img/20210627_121154.18a8d192.jpg";